import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

const FormTextField = React.memo(({ name, value, onChange, placeholder, type = 'text', required = true, ...props }) => {
  return (
    <TextField
      name={name}
      value={value}
      onChange={onChange}
      type={type}
      required={required}
      fullWidth
      variant="outlined"
      placeholder={placeholder}
      InputLabelProps={{
        shrink: false,
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          backgroundColor: '#fff',
          border: '1px solid #e2e8f0',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            '& fieldset': {
              border: 'none',
            },
          },
          '&.Mui-focused': {
            border: '1px solid #0f172a',
            '& fieldset': {
              border: 'none',
            },
          },
          '& input': {
            width: '100%',
            color: '#000',
            py: 1.5,
            px: 2,
          },
          '& input::placeholder': {
            color: '#64748b !important',
            opacity: '1 !important',
          },
        },
        '& .MuiInputLabel-root': {
          display: 'none',
        },
      }}
      {...props}
    />
  );
});

FormTextField.displayName = 'FormTextField';

FormTextField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool,
};

export default FormTextField;
